import * as React from 'react'
import styled from 'styled-components'
import { ViewBase } from '@bestyled/primitives'
import {
  commonProps,
  CommonProps,
  SupportedProps,
  borderProps,
  BorderProps,
  flexContainerProps,
  FlexContainerProps,
  flexItemProps,
  FlexItemProps
} from '@bestyled/system'

export interface FlexProps
  extends FlexContainerProps,
    FlexItemProps,
    CommonProps,
    SupportedProps {
  id?: string
}

/** The Flex component handles the flex box model, normalized for cross-platform with flutter like props. */
export const Flex = styled(ViewBase<FlexProps>('Flex'))`
    flex-wrap: nowrap;
    align-items: stretch;
    justify-content: flex-start;
    align-content: flex-start;
   ${flexContainerProps} ${flexItemProps} ${commonProps}
 ` as React.FC<FlexProps>

Flex.defaultProps = {
  alignMainAxis: 'flex-start',
  alignCrossAxis: 'stretch',
  display: 'flex'
}

export const Row = styled<React.FC<RowProps>>(Flex)`
  flex-direction: row;
  ${borderProps}
`

Row.defaultProps = {
  alignMainAxis: 'flex-start',
  alignCrossAxis: 'stretch',
  display: 'flex',
  itemType: 'Row'
}

Row.displayName = 'Row'

export const Column = styled<React.FC<ColumnProps>>(Flex)`
  flex-direction: column;
  ${borderProps}
`

Column.defaultProps = {
  alignMainAxis: 'flex-start',
  alignCrossAxis: 'stretch',
  display: 'flex',
  itemType: 'Column'
}

export interface RowProps extends FlexProps, BorderProps {}

export interface ColumnProps extends FlexProps, BorderProps {}
